import { render } from "./CreatorBigCard.vue?vue&type=template&id=07134edc"
import script from "./CreatorBigCard.vue?vue&type=script&lang=js"
export * from "./CreatorBigCard.vue?vue&type=script&lang=js"

import "./CreatorBigCard.vue?vue&type=style&index=0&id=07134edc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__